module.exports = __webpack_public_path__ + "img/庞红杰.80c78777.jpg";